import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../shared/services';

@Component({
  selector: 'app-report-not-found',
  templateUrl: './report-not-found.component.html',
  styleUrls: ['./report-not-found.component.scss'],
  standalone: false
})
export class ReportNotFoundComponent implements OnInit {
  constructor(public languageService: LanguageService, private router: Router) {}

  ngOnInit(): void {}

  navigateToReports(): void {
    this.router.navigate(['reports']);
  }
}
